import * as types from "../ActionType";

const initState = {
    notifications: [],
    loadingNotifications: true
}

const NotificationsReducer = (state = initState, action) => {
    switch (action.type) {
        case types.GET_NOTIFICATIONS:
            return { ...state, notifications: action.payload, loadingNotifications: false }
        default:
            return state;
    }
};

export default NotificationsReducer;
